import api from '../../api/index';


export default {
  namespaced: true,
  state     : {
    content: {
      list: [
        {
          title  : '123',
          content: [],
        },

      ],
    },
  },
  getters: {
    list: ({content}) => content.list,
  },
  mutations: {
    SET_CLASSIFICATION(state, value) {
      state.content.list = value;
    },
  },
  actions: {
    async get_classification({commit}) {
      try {
        const get_classification = await api.database.get_classification();
        commit('SET_CLASSIFICATION', get_classification.data);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
